import { objectSchema } from "vue-utils"
import { Nullable } from "../BaseEntity"

export interface MarriageAddress {
	Postcode: Nullable<string>
	Address1: Nullable<string>
	Address2: Nullable<string>
	Address3: Nullable<string>
	County: Nullable<string>
}

export const MarriageAddressSchema = objectSchema<MarriageAddress>({
	Postcode: Nullable(String),
	Address1: Nullable(String),
	Address2: Nullable(String),
	Address3: Nullable(String),
	County: Nullable(String),
})
